import styled from "styled-components";

export const AuthForm = styled.form`
  background: #202020;
  padding: 30px;
  border: 1px solid #9965f2;
  border-radius: 10px;
`;

export const AuthHeader = styled.div`
  font-weight: bolder;
  font-size: 30px;
  margin-block: 10% 30%;
`;

export const FormHeader = styled.div`
  font-weight: bold;
  margin-block-end: 10px;
`;

export const FormWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-block: 5px 15px;
`;

export const AuthLabel = styled.label`
  font-weight: bold;
`;

export const AuthInput = styled.input`
  width: fill-available;
  height: 50px;
  padding-inline: 35px 10px;
  border-radius: 0;
  margin-inline: auto;
`;

export const FormError = styled.div`
  width: 100%;
  text-align: center;
  color: tomato;
  font-size: small;
  height: fit-content;
  margin-top: 10px;
`;

export const AuthButton = styled.button`
  width: 60%;
  height: 50px;
  margin-block: 30px;
  margin-inline: auto;
  cursor: pointer;
`;

export const AuthRedirectText = styled.span`
  display: flex;
  justify-content: center;

  & > a {
    margin-inline-start: 5px;
  }
`;
